<template>
  <v-container>
    <v-card
      class="my-3 px-4"
    >

      <v-card-title class="ma-0 pa-0 pt-3">
        <ProductCardHeader
          class="my-0 py-0"
          :product-id="product.id"
        />
      </v-card-title>

      <div v-if="featureSwitches.TextingProductStatusToggle == null">
        Loading
      </div>
      <!-- Contains wording for paid service -->
      <TextingWelcome
        v-else-if="featureSwitches.TextingProductStatusToggle === true"
        class=""
        :is-subscribed="isSubscribed"
        :product-name="product.name"
        :subscription-status="product.subscriptionStatus"
      />
      <!-- Doesn't include mention of paid service, will be replaced -->
      <OldTextingWelcome
        v-else
        :is-subscribed="isSubscribed"
        :product-name="product.name"
      />

      <v-card-actions>
        <v-row class="px-3">
          <v-col cols="3" class="text-left">
            <v-btn @click="returnToMarketplace()">Return to Marketplace</v-btn>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="3" class="text-right">
            <v-btn color="#FF9E15" :disabled="isLoading" :loading="isLoading" @click="enableProduct()">{{ isSubscribed ? 'Manage Subscription' : 'Next' }}</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import productIdMappingMixin from '@/mixins/productIdMappingMixin';

import ProductCardHeader from '@/components/products/shared/ProductCardHeader';
import OldTextingWelcome from './OldTextingWelcome.vue';
import TextingWelcome from './TextingWelcome.vue';

export default {
  name: 'TextingView',
  components: {
    ProductCardHeader,
    OldTextingWelcome,
    TextingWelcome
  },
  mixins: [productIdMappingMixin],
  data () {
    return {
      isLoading: false
    };
  },
  computed: {
    ...mapState([
      'agencyUser',
      'agency',
      'featureSwitches'
    ]),
    ...mapGetters(['getProductByProductId']),
    product () {
      return this.getProductByProductId(this.getProductId('texting'));
    },
    isSubscribed () {
      if (this.product) {
        return this.product.isSubscribed;
      }
      return false;
    },
    isEnabled () {
      if (this.product) {
        return this.product.enabled;
      }
      return false;
    }
  },
  created () {
    this.getFeatureSwitches();
  },
  methods: {
    ...mapActions([
      'newSetProductSubscription',
      'setProductSubscription',
      'getFeatureSwitches',
      'getProducts'
    ]),
    ...mapMutations([
      'setError'
    ]),
    returnToMarketplace () {
      this.$router.push('/marketplace');
    },
    async enableProduct () {
      if (!this.isSubscribed) {
        this.isLoading = true;
        let rs = await this.newSetProductSubscription({
          productId: this.product.id,
          subscription: true
        });
        if (rs.code !== 0) {
          this.setError({ errorMessage: `Error - Unable to set subscription. Message: ${rs.message}` });
          this.isLoading = false;
          return;
        }
        // Need to reload after subscribing, to get new texting product info
        let rs2 = await this.getProducts();
        if (rs2.code !== 0) {
          this.setError({ errorMessage: `Error - Unable to get updated product. Please reload. Message: ${rs2.message}` });
          this.isLoading = false;
          return;
        }
      }
      await this.resolveTextingProfile();
      this.isLoading = false;
    },
    async resolveTextingProfile () {
      try {
        const response = await this.$api.getTextingProfile();
        if (!response.data) {
          throw new Error(null);
        } else if (response.data.code === 3) {
          this.$router.push({ name: 'TextingSetupConf' });
          return;
        } else if (response.data.code === 2 || !response.data.data[0]) {
          this.$router.push({ name: 'TextingSetup' });
          return;
        } else if (response.data.code === 0) {
          this.$router.push({ name: 'TextingSetupMod' });
          return;
        } else {
          throw new Error('invalid response');
        }
      } catch (err) {
        this.setError({ errorMessage: `Error - Unable to get Agency Texting Data. Please contact HawkSoft Support.` });
      }
    }
  }
};

</script>
